import React, { useState, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { editOtherLoanDetails } from "../../actions/shg";
import Spinner from "../layout/Spinner";

const EditOtherLoanTypes = ({
  savedMessage,
  auth: { isAuthenticated, user, users, loading },
  allLoanTypes,
  editOtherLoanDetails,
  onUpdateModalChange,
}) => {
  //formData
  const [formData, setFormData] = useState({
    otherLoanType:
      allLoanTypes && allLoanTypes.otherLoanType
        ? allLoanTypes.otherLoanType
        : "",

    isSubmitted: false,
  });

  const { otherLoanType } = formData;

  const onInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onUpdate = (e) => {
    e.preventDefault();
    const finalData = {
      recordId: allLoanTypes ? allLoanTypes._id : "",
      otherLoanType: otherLoanType,
      otherLoanTypeEnteredById: user._id,
      otherLoanTypeEnteredByName: user.userName,
      otherLoanTypeEnteredDateTime: new Date().toLocaleString("en-GB"),
      institutionId: user.institutionId,
    };
    editOtherLoanDetails(finalData);
    onUpdateModalChange(true);
  };

  return !isAuthenticated || !user || !users ? (
    <Spinner />
  ) : (
    <Fragment>
      <div className="container container_align">
        <form className="row" onSubmit={(e) => onUpdate(e)}>
          <div className="row col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="col-lg-10 col-md-12 col-sm-12 col-12">
              <label className="label-control"> Edit Other loan Name* :</label>
              <input
                type="text"
                name="otherLoanType"
                value={otherLoanType}
                className="form-control"
                onChange={(e) => onInputChange(e)}
                required
              />
            </div>
          </div>

          <div className="col-md-10 col-lg-10 col-sm-12 col-12 text-left">
            {loading ? (
              <button
                className="btn sub_form btn_continue Save float-right"
                disabled
              >
                Loading...
              </button>
            ) : (
              <input
                type="submit"
                name="Submit"
                value="Update"
                className="btn sub_form btn_continue Save float-right"
              />
            )}
          </div>
        </form>
      </div>
    </Fragment>
  );
};

EditOtherLoanTypes.propTypes = {
  auth: PropTypes.object.isRequired,
  shg: PropTypes.object.isRequired,
  editOtherLoanDetails: PropTypes.func.isRequired,
  savedMessage: PropTypes.string,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  shg: state.shg,
  savedMessage: state.auth.savedMessage,
});

export default connect(mapStateToProps, {
  editOtherLoanDetails,
})(EditOtherLoanTypes);
